// const notDemoOrProdEnv = !['DEMO', 'PROD'].includes(process.env.REACT_APP_ENV);

export const DELETE_DELIVERY_FEATURE_FLAG = true;
export const DELIVERIES_ORDER_NUMBER_FEATURE_FLAG = true;
export const CANCELLED_SURGERY_FEATURE_FLAG = true;
export const HIDE_JNJ_SADL_DATA = true;
export const HOSPITAL_SURGERY_LIST_ON = true;
export const TURNAROUND_PAGE_FEATURE_FLAG = true;
export const TURNAROUND_PHASE_3_FEATURE_FLAG = true;
export const PATIENT_INITIALS_FEATURE_FLAG = true;
export const SKIP_IMPLANT_PROCESSING_FEATURE_FLAG = true;
export const MANAGE_BUTTON_WIDTHS = true;
export const IMPLANT_KITTING_FEATURE_FLAG = false;
export const NEW_ORDER_PAGE_ON = true;
export const CREATE_NEW_SURGERY_ON = false;
export const PATIENT_INITIALS_VALIDATION_FEATURE_FLAG = true;
export const CHECKED_OUT_PDF_ON = true;
export const HELP_BUTTON_ON = true;
export const ACTION_ITEMS_V2_ON = true;
export const PAST_SURGERIES_ON = true;
export const SURGERY_ATTACHMENTS_ON = true;
export const SKIP_CHECK_IN_INSPECTION_OPTIONS_ON = false;
export const PIN_LOGIN_ON = true;
